import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBestPlace } from "../bestPlaceModal";

export const getAllBestPlaces = createAsyncThunk(
  "BestPlace/FindAllBestPlace",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/FindAllBestPlace`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Client BestPlaceImages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createBestPlace = createAsyncThunk(
  "BestPlace/InsertBestPlace",
  async (BestPlaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/InsertBestPlace`,
        BestPlaceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating client BestPlaceImage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBestPlace = createAsyncThunk(
  "BestPlace/UpdateBestPlace",
  async (BestPlaceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/UpdateBestPlace`,
        BestPlaceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating client BestPlaceImage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBestPlace = createAsyncThunk(
  "BestPlace/DeleteBestPlace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/DeleteBestPlace`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting client BestPlaceImage :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBestPlaceByID = createAsyncThunk(
  "BestPlace/FindByIDBestPlace",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/FindByIDBestPlace`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title,
        Image: result?.BestPlaceImage,
        IsActive: result.IsActive ? 1 : 2,
      } as IBestPlace;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching client BestPlaceImage :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveBestPlaces = createAsyncThunk(
  "BestPlace/FindAllActiveBestPlace",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/BestPlace/FindAllActiveBestPlace`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Client BestPlaceImages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveBestPlace = createAsyncThunk(
  "BestPlace/ActiveInActiveBestPlace",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/ActiveInActiveBestPlace`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive client BestPlaceImage :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const BestPlaceImageUpload = createAsyncThunk(
  "BestPlace/BestPlaceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BestPlace/BestPlaceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload client BestPlaceImage Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
